/* eslint-disable security-node/detect-crlf */

import { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { PaymentProvider, RegisterStepProvider, useAuth, ValidateUserProvider } from 'context'

import { Login, Register, ResetPassword, ValidateUser } from 'pages'
import { ExternalPaymentGateway } from 'pages/ExternalPaymentGateway'

import { CreatePassword } from '../pages/CreatePassword/index'

import PrivateRoute from './PrivateRoute/index'
import DashboardClientsRoutes from './DashboardClientsRoutes'
import PublicRoute from './PublicRoute'

const AppRouter: React.FC = () => {
  const [isReady, setIsReady] = useState<boolean>(false)
  const { checkAuth } = useAuth()

  const loadApplication: () => void = async () => {
     await checkAuth()
    setIsReady(true)
  }

  useEffect(() => {
    loadApplication()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isReady) return <h1>Cargando...</h1>

  return (
    <PaymentProvider>
      <BrowserRouter>
      <Routes>
          <Route path='/' element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          <Route path='/external-payment-gateway' element={<ExternalPaymentGateway />} />
          <Route path='/reset-password' element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          } />
          <Route path='/create-new-password/:newToken' element={
            <PublicRoute>
              <CreatePassword />
            </PublicRoute>
          } />
          <Route path='/register' element={
            <PublicRoute>
              <RegisterStepProvider>
                <Register />
              </RegisterStepProvider>
            </PublicRoute>
          } />
          <Route path='/validate-user' element={
            <PublicRoute>
              <ValidateUserProvider>
                <ValidateUser />
              </ValidateUserProvider>
            </PublicRoute>
          } />
          <Route path='/*' element={
            <PrivateRoute>
              <DashboardClientsRoutes />
            </PrivateRoute>
          } />
          <Route path="*" element={<Navigate to='/' />} />
        </Routes>
      </BrowserRouter>
    </PaymentProvider>
  )
}

export default AppRouter
